import { Redirect } from 'react-router-dom';
import { useAccessLevel, useAppContext } from 'core/app/AppContext';
import LookerEmbedDashboardPage from 'sections/looker-dashboard/components/LookerEmbedDashboardPage';

export function HomePage() {
  const { isSignedIn } = useAppContext();
  const { accessLevel, brandIds, siteIds } = useAccessLevel();

  if (!isSignedIn()) {
    return <Redirect to="/" />;
  } else {
    switch (accessLevel) {
      case 'SaleCycle':
      // fall through
      case 'MultiSite':
        return <LookerEmbedDashboardPage />;
      case 'Brand':
        return <Redirect to={`/brands/${brandIds[0]}/dashboard`} />;
      case 'Site':
        return <Redirect to={`/sites/${siteIds[0]}/dashboard`} />;
      default:
        return <LookerEmbedDashboardPage />;
    }
  }
}
